import React, { useEffect } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import LayoutProtect from "@components/enviroment-protect/LayoutProtect";
import "../styles/globals.css";
import "../styles/helper-spacing.css";
import "react-photo-view/dist/react-photo-view.css";

// Legacy providers and widgets are not part of the standalone landing bundle.
const LegacyApp = dynamic(() => import("@components/LegacyApp"));
export default function MyApp(props: any) {
  const { Component, pageProps } = props;
  const router = useRouter();
  useEffect(() => {
    // A new document is required at this boundary: removing script tags cannot
    // unload third-party trackers already initialized on a legacy page.
    const boundary = (url: string) => {
      const path = new URL(url, window.location.origin).pathname;
      const target = /^\/(?:en\/|es\/)?franquicias\/?$/.test(path);
      if (target !== !!Component.standalone) {
        window.location.assign(url);
        const error = Object.assign(new Error("Full document navigation"), {
          cancelled: true,
        });
        router.events.emit("routeChangeError", error, url, { shallow: false });
        throw error;
      }
    };
    router.events.on("routeChangeStart", boundary);
    return () => router.events.off("routeChangeStart", boundary);
  }, [Component.standalone, router.events]);

  if (Component.standalone)
    return (
      <LayoutProtect>
        <Component {...pageProps} />
      </LayoutProtect>
    );
  return <LegacyApp {...props} />;
}
